<template>
  <div class="range" :class="{ 'range--disabled': disabled }">
    <slot name="start"></slot>
    <div class="range-content" ref="content">
      <div class="range-runway" :style="{ 'border-top-width': barHeight + 'px' }"></div>
      <div class="range-progress" :style="{ width: progress + '%', height: barHeight + 'px' }"></div>
      <div class="range-thumb" ref="thumb" :style="{ left: progress + '%' }"></div>
    </div>
    <slot name="end"></slot>
  </div>
</template>

<style scoped>
  .range {
    position: relative;
    display: flex;
    height: 25px;
    line-height:25px;
  }

  .range-content {
    position: relative;
    flex: 1;
    margin-right:25px;
  }

  .range>* {
    display: -ms-flexbox;
    display: flex;
    display: -webkit-box;
  }
  .range-runway {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: -25px;
    border-top-color: #dadada;
    border-top-style: solid;
    border-radius: 2.5px;
}
.range-progress {
    position: absolute;
    display: block;
    background-color: #12a3ff;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    border-top-left-radius: 2.5px;
    border-bottom-left-radius:  2.5px;
}
.range-thumb {
    background-color: #12a3ff;
    position: absolute;
    left: 0;
    top: 0;
    width: 25px;
    height: 25px;
    border-radius: 100%;
    cursor:move;
    box-shadow: 0 1px 3px rgba(0,0,0,.4);
}
</style>

<script>
  import draggable from './draggable';
  export default {
    name: 'range',
    props: {
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      step: {
        type: Number,
        default: 1
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: {
        type: Number
      },
      barHeight: {
        type: Number,
        default: 1
      }
    },
    computed: {
      progress() {
        const value = this.value;
        if (typeof value === 'undefined' || value === null) return 0;
        return Math.floor((value - this.min) / (this.max - this.min) * 100);
      }
    },
    mounted() {
      const thumb = this.$refs.thumb;
      const content = this.$refs.content;
      const getThumbPosition = () => {
        const contentBox = content.getBoundingClientRect();
        const thumbBox = thumb.getBoundingClientRect();
        return {
          left: thumbBox.left - contentBox.left,
          top: thumbBox.top - contentBox.top,
          thumbBoxLeft: thumbBox.left
        };
      };
      let dragState = {};
      draggable(thumb, {
        start: (event) => {
          if (this.disabled) return;
          const position = getThumbPosition();
          const thumbClickDetalX = event.clientX - position.thumbBoxLeft;
          dragState = {
            thumbStartLeft: position.left,
            thumbStartTop: position.top,
            thumbClickDetalX: thumbClickDetalX
          };
        },
        drag: (event) => {
          if (this.disabled) return;
          const contentBox = content.getBoundingClientRect();
          const deltaX = event.pageX - contentBox.left - dragState.thumbStartLeft - dragState.thumbClickDetalX;
          const stepCount = Math.ceil((this.max - this.min) / this.step);
          const newPosition = (dragState.thumbStartLeft + deltaX) - (dragState.thumbStartLeft + deltaX) % (
            contentBox.width / stepCount);
          let newProgress = newPosition / contentBox.width;
          if (newProgress < 0) {
            newProgress = 0;
          } else if (newProgress > 1) {
            newProgress = 1;
          }
          this.$emit('input', Math.round(this.min + newProgress * (this.max - this.min)));
        },
        end: () => {
          if (this.disabled) return;
          this.$emit('change', this.value);
          dragState = {};
        }
      });
    }
  };

</script>
